import React, { Component } from "react";
import parse from "html-react-parser";
import Select from 'react-select';
import { cloneDeep } from 'lodash';

import "./style.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

import {Button} from '@learningblocks/exp-components/lib/Button';

// Icons
import IconCorrect from "./img/Correct-icon.svg";
import IconIncorrect from "./img/Incorrect-icon.svg";
import close from "../../../img/close.svg"

import {
  HighlightHTML
} from "@learningblocks/storybook-components";

export class ProtocolTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      feedbackShown: false,
      feedbackCorrect: false,
      feedback: "Default",
      updated: false,
      tableData: this.props.tableData,
      dropDownOptions: this.props.tableData.dropDownOptions
    }
  }

  numsOnly = text => {
    text = text.replace(/[^0-9.]/g, "")

    return text;
  };

  allInputsSelected = (tableData) => {

    let inputsFilled = true;

    tableData.data.forEach((row, rowIndex)=>{
      row.forEach((item, itemIndex)=>{
        if(itemIndex === 1 && item === null){
          inputsFilled = false;
        }
      })
    })

    return inputsFilled;

  }

  handleInputChange = (e, row, index) => {
    if (this.numsOnly(e.target.value) !== e.target.value) {
      e.target.setCustomValidity("Please input an integer");
      e.target.reportValidity();
    } else {
      e.target.setCustomValidity("");
    }

    let tableData = this.state.tableData;
    tableData.data[row][index].input = this.numsOnly(e.target.value)

    this.setState({
      tableData: tableData,
      updated: this.allInputsSelected(tableData)
    });

  };

  handleSelectChange = (selectedOption, row, index) => {

    let tableData = this.state.tableData;
    tableData.data[row][index].dropDown = selectedOption

    this.setState({
      tableData: tableData,
      updated: this.allInputsSelected(tableData)
    });

  };

  handleReset = (e) => {
    let tableData = this.state.tableData;
    tableData.data = cloneDeep(tableData.data.map((row, rowIndex) => {
      return row.map((item, itemIndex) => {
        if(item.hasOwnProperty('dropDown')){
          item.dropDown = null;
        }
        if(item.hasOwnProperty('input')){
          item.input = "";
        }
        return item
      })
    }))

    this.setState({
      tableData: tableData,
      updated: false
    }, () => {
      this.props.setProtocolTableData({
        tableData: this.state.tableData,
        submitted: false
      });
    });
  }

  handleSubmit = (e) => {
    //e.preventDefault();
    this.getFeedback();
    this.props.setProtocolTableData({
      tableData: this.state.tableData,
      submitted: true
    });
    this.setState({
      updated: false
    })
    // this.props.showModal({
    //   display: false
    // });
  };

  getFeedback = () => {

    let masterMixVolume = true;
    let templateSelection = true;
    let templateVolume = true;
    let correct = true;
    let containsNull = false;

    let feedback = "Default";

    this.state.tableData.data.forEach((row, rowIndex)=>{
      row.forEach((item, itemIndex)=>{
        if(itemIndex === 1){
          if(item.input === "" || item.input === null){
            containsNull = true;
          }
          if(item.input !== "" && item.input !== null && item.input !== item.answer){
            masterMixVolume = false;
          }
        }
        if(itemIndex === 2){
          if(item.dropDown === "" || item.dropDown === null){
            containsNull = true;
          }
          if(item.dropDown !== "" && item.dropDown !== null && item.dropDown.value !== item.answer){
            templateSelection = false;
          }
        }
        if(itemIndex === 3){
          if(item.input === "" || item.input === null){
            containsNull = true;
          }
          if(item.input !== "" && item.input !== null && item.input !== item.answer){
            templateVolume = false;
          }
        }
      });
    });

    if(!masterMixVolume){
      feedback = "Not quite. You have included an incorrect amount of master mix. You will add the same amount of master mix into each of the 4 tubes. How much master mix are you adding to each tube? Click “Reset table” to try again.";
      correct = false;
    }

    if(!templateSelection){
      feedback = "Not quite. The sample tube will contain a template of unknown DNA. The positive controls will each contain DNA that gives a positive result for either the taster allele or non-taster allele. The negative control will contain a template that specifically gives no result. You can try again by clicking “Reset table.”";
      correct = false;
    }

    if(!templateVolume){
      feedback = "Not quite. You have included an incorrect amount of template. You will add the same amount of template into each of the 4 tubes. How much template are you adding to each tube? You can try again by clicking “Reset table.”";
      correct = false;
    }

    if([
        masterMixVolume,
        templateSelection,
        templateVolume
    ].filter(condition => !condition).length > 2){
      feedback = "Not quite. You will add the same amount of master mix and template into each of the 4 tubes. The total volume in each tube will then be the same. However, the template that you add to each tube will be different. You can try again by clicking “Reset table.”"
      correct = false;
    }

    if(
      !containsNull &&
      masterMixVolume &&
      templateSelection &&
      templateVolume
    ){
      feedback = "Well done! You have correctly noted that 24 µl of master mix and 1 µl of template will be added to each of the 4 tubes. This brings the total volume in each tube to 25 µl. The sample tube will contain the extracted DNA. The 2 positive controls will contain either the taster allele control DNA or the non-taster allele control DNA. The negative control will not contain any DNA as it will be replaced with 1 µl of DNase-free water. Now we know that we need at least 96 µl of master mix for 4 reactions. To be on the safe side, let’s prepare 1 extra portion of the master mix, so that we have enough for 5 reactions."
      correct = true;
    }

    this.setState({
      feedback: feedback,
      feedbackCorrect: correct,
      feedbackShown: (feedback !== "Default")
    })
  }

  close = () => {
    this.setState({
      feedbackShown: false
    });
  };

  render() {
    return (
      <div className="ProtocolTable notebook">
        <div className="notebook-content">
          <div className="notebook-content__body">
            {<div className="title">
              <h2>Template Selection Table</h2>
            </div>}
            <div
              className="endDescription"
              style={{whiteSpace: "pre-wrap", textAlign: "left", marginTop: "36px"}}
            >{<HighlightHTML
              content={this.props.tableData.description}
              getContentData={this.props.getGlossaryItem()}
              openGlossary={this.props.onOpenGlossary}
            />}</div>
            <div style={{display: "flex", flexDirection: "row", marginTop: "16px"}}>
              <div style={{border: "1px solid "+colors.navy2, background: colors.navy5, borderRadius: "5px", padding: "8px", flex: "50%"}} >
                <h4 style={{textAlign: "center", margin: "12px 0"}}>Postive control</h4>
                <p style={{textAlign: "center"}}>{"A positive control is a sample in an experiment that produces a known positive result. It is used to confirm that all of your reagents work as expected."}</p>
              </div>
              <div style={{border: "1px solid "+colors.navy2, background: colors.navy5, marginLeft: "16px", borderRadius: "5px", padding: "8px", flex: "50%"}} >
                <h4 style={{textAlign: "center", margin: "12px 0"}}>Negative control</h4>
                <p style={{textAlign: "center"}}>{"A negative control verifies that a result is not produced when none is expected. This can help to confirm that your samples were not contaminated."}</p>
              </div>
            </div>
            <div style={{border: "1px solid "+colors.navy2, background: colors.navy5, marginTop: "16px", borderRadius: "5px", padding: "8px"}} >
                <h4 style={{textAlign: "center", margin: "12px 0"}}>Master mix</h4>
                <p style={{textAlign: "center"}}>{"When you have to set up multiple reactions that share many reagents, creating a master mix can save time, and reduce tedious pipetting and unintentional errors. A master mix has all the reagents that are common among each of the reactions, but it does not include the reagent(s) that makes each reaction unique. Once made, a master mix can be added to each tube, so you know that the same concentration of each component is present in each reaction. This means you have to do much less pipetting."}</p>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: "32px"
            }}>
              <div style={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: colors.navy1
              }}>
                {this.state.tableData.headings.map((heading, index) => (
                  <div
                    style={{
                      borderTopWidth: 1,
                      borderLeftWidth: 1,
                      borderBottomWidth: "1px",
                      borderColor: colors.navy4,
                      borderStyle: "solid",
                      flexBasis: 1,
                      flexGrow: 1,
                      flexShrink: 1,
                      borderRightWidth: index === this.state.tableData.headings.length - 1 ? "1px" : 0,
                    }}
                  >
                    <p style={{
                      color: "white",
                      fontSize: "16px",
                      padding: 8,
                      margin: 0,
                      whiteSpace: "pre-wrap"
                    }}>{parse(heading)}</p>
                  </div>
                ))}
              </div>
              {this.state.tableData.data.map((row, rowIndex)=>(
                <div style={{
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: (rowIndex === 0)?"white":null
                }}>
                {row.map((item, itemIndex) => (
                  <div
                    style={{
                      borderBottomWidth: "1px",
                      borderTopWidth: "1px",
                      borderLeftWidth: "1px",
                      borderColor: colors.navy4,
                      borderStyle: "solid",
                      marginBottom: -1,
                      flexBasis: 1,
                      flexGrow: 1,
                      flexShrink: 1,
                      backgroundColor: itemIndex === 0 ? colors.navy1 : null,
                      borderRightWidth: itemIndex === row.length - 1 ? "1px" : 0
                    }}
                  >
                    {item.hasOwnProperty("fixed")?(
                      <p style={{
                        fontSize: "16px",
                        padding: 8,
                        margin: 0,
                        color: itemIndex === 0 ? "white" : null
                      }}>{parse(item.fixed)}</p>
                    )
                    :
                    item.hasOwnProperty("dropDown")?(
                      <div className="custom-select">
                        <Select
                          isSearchable={false}
                          value={item.dropDown}
                          onChange={e => this.handleSelectChange(e, rowIndex, itemIndex)}
                          options={this.state.dropDownOptions}
                        />
                      </div>
                    )
                    :
                    item.hasOwnProperty("input")?(
                      <div className="input-group">
                        <input onChange={e => this.handleInputChange(e, rowIndex, itemIndex)} type="text" placeholder="Enter μl" id={"ProtocolTable_"+rowIndex+"_"+itemIndex} value={item.input}/>
                        <div className="input-group-append">
                          <span class="input-group-text">μl</span>
                        </div>
                      </div>
                    ):null
                    }
                  </div>
                ))}
                </div>
              ))}
            </div>
            <div style={{
              display: (this.state.feedbackShown)?"flex":"none",
              flexDirection: "row",
              justifyContent: "center",
              background: (this.state.feedbackCorrect)?"rgba(132,190,96,0.1)":"rgba(237,52,49,0.1)",
              border: "2px solid "+(this.state.feedbackCorrect?colors.green1:colors.red1),
              borderRadius: "5px",
              marginTop: "16px",
              padding: "8px"
            }}>
              <div>
                <img alt="" src={(this.state.feedbackCorrect)?IconCorrect:IconIncorrect} />
              </div>
              <p style={{margin: "auto 8px", hyphens: "auto", flex: 1}}>
                {parse(this.state.feedback)}
              </p>
              <div
                aria-label="Close Button"
                tabIndex={0}
                className="close-feedback"
                onKeyDown={e => {
                  if (e.keyCode === 13 || e.keyCode === 32) this.close(e);
                }}
                onClick={this.close}
                style={{
                  margin: "auto"
                }}
              >
                <img
                  style={{
                    display: "inline-block",
                    top: "3px",
                    position: "relative"
                  }}
                  src={close}
                  alt="Close button"
                />
              </div>
            </div>
            <div style={{display: "flex", marginTop: "16px", justifyContent: "flex-end"}}>
              <Button className='secondary resetProtocolTable' onClick={(e)=>this.handleReset(e)}>
                Reset table
              </Button>
              <Button disabled={!this.state.updated} className='submitProtocolTable' onClick={(e)=>this.handleSubmit(e)}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
